export const voiceAIRouteNames = {
  aiAgents: 'ai-agents',
  aiAgentsDefault: 'ai-agents-default',
  aiAgentsEditAgent: 'ai-agents-edit-agent',
  aiAgentsVoiceAiHome: 'ai-agents-voice-ai-home',
  aiAgentsVoiceAiEditAgent: 'ai-agents-voice-ai-edit-agent',
}
